import type { ResolvedThemeMode, ThemeMode } from '@shigo-ui/theme';
import { createContext } from 'react';

export type ShigoThemeContextValue = {
  resolvedTheme: ResolvedThemeMode;
  themeMode: ThemeMode;
  setThemeMode: (themeMode: ThemeMode) => void;
};

export const ShigoThemeContext = createContext<ShigoThemeContextValue | null>(null);
